module.exports = __webpack_public_path__ + "img/E户型2.1ca41eb4.png";